<template>
  <el-dialog
    class="download-dialog"
    :visible.sync="visible"
    width="40%"
    center>
    <span slot="title" class="dialog-title" v-show="!successFlag">提交信息 下载资料</span>
    <div class="dialog-content dib tc" v-show="!successFlag">
      <el-form ref="downloadForm" label-position="top" status-icon :model="downloadForm" :rules="downloadRules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="downloadForm.name" :maxlength="20" class="form-input name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input  v-model.number="downloadForm.contact" :maxlength="15" class="form-input contact"></el-input>
        </el-form-item>
        <el-form-item label="图片验证码"  prop="validate">
          <el-input :maxlength="4" v-model="downloadForm.validate" class="form-input validate">
            <img class="validate-img" slot="suffix" @click="changeCode" @mousedown="disableDrag"
                 :src="validateUrl" alt="请求失败,请检查网络"/>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="downloadForm.email" :maxlength="40" class="form-input email"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="downloadForm.company"  :maxlength="20" class="form-input company"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="submit-button" @click="submitMessage" round>提交信息</el-button>
    </div>
    <div class="dialog-content2 dib tc" v-show="successFlag">
      <img class="success-img" src="../../assets/img/downloadPanel/success-2.png" alt="资料已发送到您的邮箱"/>
      <div class="success-misc">资料已发送到您的邮箱，请查收</div>
      <el-button class="direct-download" @click="saveFile" round>点击直接下载</el-button>
      <iframe class="download-frame" name="downloadFrame"></iframe>
    </div>
  </el-dialog>
</template>
<script>
import { Loading } from 'element-ui'

export default {
  name: 'downloadPanel',
  data () {
    var nameValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能为空'))
      }
      callback()
    }
    var contactValidate = (rule, value, callback) => {
      //        var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/ // 电话
      var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/ // 手机号码
      if (!value) {
        return callback(new Error('联系方式不能为空'))
      }
      if (isMob.test(value)) {
        callback()
      } else {
        callback(new Error('联系方式格式错误'))
      }
    }
    var emailValidate = (rule, value, callback) => {
      var isEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/ // 邮箱
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      if (isEmail.test(value)) {
        callback()
      } else {
        callback(new Error('邮箱格式错误'))
      }
    }
    var codeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'))
      }
      callback()
    }
    var codeValidate2 = (rule, value, callback) => {
      this.$api.post('/base/verifycode', { code: value }, (r) => {
        if (r.code === 0) {
          callback()
        } else {
          this.changeCode()
          callback(new Error('验证码错误！'))
        }
      })
    }
    var companyValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('公司名称不能为空'))
      }
      callback()
    }
    return {
      visible: false,
      successFlag: false,
      downloadForm: {
        name: '',
        contact: '',
        validate: '',
        email: '',
        company: '',
        fileId: 0,
        listId: 0,
        loadingText: '正在提交您的信息',
        responseText: '资料已发送到您的邮箱，请查收',
        loadingArray: []
      },
      downloadRules: {
        name: [
          { validator: nameValidate, trigger: 'blur', required: true }
        ],
        contact: [
          { validator: contactValidate, trigger: 'blur', required: true }
        ],
        validate: [
          { validator: codeValidate, trigger: 'blur', required: true },
          { validator: codeValidate2, trigger: 'submit' }
        ],
        email: [
          { validator: emailValidate, trigger: 'blur', required: true }
        ],
        company: [
          { validator: companyValidate, trigger: 'blur', required: true }
        ]
      },
      validateUrl: this.$global.globalPath + 'api/document/getcode'
    }
  },
  methods: {
    openDialog (bool, code) {
      this.visible = true
      this.successFlag = bool
      this.loadingArray = []
      this.downloadForm.fileId = this.$route.query.item
      this.downloadForm.listId = this.$route.query.list
      this.changeCode()
      this.$nextTick(() => {
        this.$refs['downloadForm'].resetFields()
      })
    },
    submitMessage () {
      this.loadingText = '正在提交您的信息'
      let loading = Loading.service({
        target: '.el-dialog--center',
        text: this.loadingText
      })
      this.loadingArray.push(loading)
      this.$refs['downloadForm'].validate((valid) => {
        if (valid) {
          this.submitInfo()
        } else {
          this.loadingArray.forEach(item => item.close())
          return false
        }
      })
    },
    submitInfo () {
      let form = {
        name: this.downloadForm.name,
        mobile: this.downloadForm.contact,
        email: this.downloadForm.email,
        company: this.downloadForm.company,
        zid: this.downloadForm.fileId
      }
      this.$api.post('/document/user_info', form, (r) => {
        if (r.code === 0) {
          this.loadingText = '正在发送资料至您的邮箱'
          let postform = {
            postemail: this.downloadForm.email,
            postname: this.downloadForm.name,
            postid: this.downloadForm.fileId
          }
          this.sendEmail(postform)
        } else {
          this.loadingArray.forEach(item => item.close())
          this.$message.error(r.data || '信息提交失败,请检查网络')
        }
      })
    },
    sendEmail (form) {
      this.$api.post('/document/sendemail', form, (r) => {
        if (r.code === 0) {
          this.successFlag = true
          this.loadingArray.forEach(item => item.close())
          this.responseText = '资料已发送到您的邮箱，请查收'
        } else {
          this.loadingArray.forEach(item => item.close())
          this.$message.error(r.message || '邮件发送失败,请检查网络')
        }
      })
      this.loadingArray.forEach(item => {
        item = null
      })
    },
    saveFile () {
      this.openPostWindow(this.$global.globalPath + 'api/document/download', this.downloadForm.fileId)
    },
    openPostWindow (url, username) {
      let tempForm = document.createElement('form')
      let tempFrame = document.getElementsByName('downloadFrame')[0]
      tempForm.id = 'tempForm1'
      tempForm.method = 'POST'
      tempForm.action = url
      tempForm.target = 'downloadFrame'
      tempForm.innerHTML = "<input type='hidden' name='postid' value='" + username + "'/>" +
          tempForm.addEventListener('onsubmit', () => {
            tempFrame.contentWindow.open('about:blank', '_self')
          })
      document.body.appendChild(tempForm)
      tempForm.dispatchEvent(new Event('onsubmit'))
      tempForm.submit()
      document.body.removeChild(tempForm)
    },
    changeCode () {
      let a = this.validateUrl
      this.validateUrl = ''
      this.$nextTick(() => {
        this.validateUrl = a
      })
    },
    disableDrag (event) {
      event.preventDefault()
    }
  },
  created () {
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/downloadPanel.scss";
</style>



// WEBPACK FOOTER //
// downloadPanel.vue?f23c952c